export default __webpack_public_path__ + "static/media/dangerIcon.62a4e703.svg";